"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Title2: function() {
        return _Title2.Title2;
    },
    title2ClassNames: function() {
        return _useTitle2Stylesstyles.title2ClassNames;
    }
});
const _Title2 = require("./Title2");
const _useTitle2Stylesstyles = require("./useTitle2Styles.styles");
